import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {
  creditCheckLogListModelFactory,
  CreditCheckLogModel,
} from "./high-radius.model";
import {toHttpParams} from "../helpers/helpers";

@Injectable()
export class HighRadiusService {
  private url: string = "/api/high-radius";

  constructor(public http: HttpClient) {}
  highRadiusCreditCheck(projectId: string): Promise<CreditCheckLogModel[]> {
    return this.http.post<CreditCheckLogModel[]>(`${this.url}/credit-check`, {projectId})
      .toPromise();
  }

  getCreditCheckLogs(
    projectId: string = "",
    customerBpId: string = "",
    limit: number = 0,
  ): Promise<CreditCheckLogModel[]> {
    const params = toHttpParams({projectId, customerBpId, limit});
    return this.http.get<CreditCheckLogModel[]>(`${this.url}/credit-check-logs`, {params})
      .pipe(map(creditCheckLogListModelFactory))
      .toPromise();
  }
}
